<div
  *ngIf="(showSideNavigation$ | async) && !(hideSideNavigationIa$ | async)"
  class="side-navigation-container"
  data-e2e-id="side-nav"
>
  <div class="side-navigation">
    <div class="side-navigation-contents">
      <app-icon
        *ngIf="isIaNavEnabled; else accountMenuTrigger"
        class="invoice2go-logo-wrapper-ia"
        [icon]="invoice2goLogo"
      >
      </app-icon>
      <ng-template #accountMenuTrigger>
        <app-account-menu-trigger
          class="account-menu"
          [companyName]="companyName$ | async"
          [userEmail]="userEmail"
          (onToggleMenu)="onToggleMenu($event)"
        >
        </app-account-menu-trigger>
      </ng-template>

      <app-logout
        *ngIf="isAccountMenuOpen"
        class="logout"
        [userEmail]="userEmail"
      ></app-logout>

      <nav [hidden]="isAccountMenuOpen" class="navigation">
        <ul class="navigation-groups">
          <li
            *ngFor="let navItemGroup of navItemGroups$ | async"
            class="navigation-groups-item"
          >
            <ul class="navigation-list">
              <li
                *ngFor="let navItem of navItemGroup"
                class="navigation-list-item"
              >
                <i2g-router-link
                  [route]="navItem.route"
                  [e2eId]="navItem.e2eId"
                  [trackingObject]="trackingObject"
                  [trackingAction]="navItem.trackingAction"
                  [trackingAdditionalProperties]="
                    navItem.trackingAdditionalProperties
                  "
                >
                  <div class="nav-contents">
                    <span class="label">
                      {{ navItem.label | translate }}
                    </span>

                    <span
                      *ngIf="navItem.metadata"
                      class="navigation-list-item-metadata"
                      [ngClass]="navItem.metadata.customClass"
                    >
                      {{ navItem.metadata.value }}
                    </span>
                  </div>
                </i2g-router-link>
              </li>
            </ul>
          </li>
        </ul>
      </nav>

      <ng-container *ngIf="isPurchasable && !!paywallCta && !isAccountMenuOpen">
        <div *ngIf="!isIaNavEnabled" class="upgrade-action-separator"></div>

        <button
          *ngIf="isIaNavEnabled; else oldButton"
          i2gButton
          buttonStyle="default-reversed"
          type="button"
          class="upgrade-action-ia"
          trackable
          [trackingObject]="trackingObject"
          [trackingAction]="(upgradeCta$ | async).action"
          (click)="onUpgradeAction()"
        >
          {{ (upgradeCta$ | async).copy | translate }}
        </button>
        <ng-template #oldButton>
          <button
            type="button"
            class="upgrade-action"
            trackable
            [trackingObject]="trackingObject"
            [trackingAction]="(upgradeCta$ | async).action"
            (click)="onUpgradeAction()"
          >
            {{ (upgradeCta$ | async).copy | translate }}
          </button>
        </ng-template>
      </ng-container>
    </div>

    <app-icon
      *ngIf="!isIaNavEnabled"
      class="invoice2go-logo-wrapper"
      [icon]="invoice2goLogo"
    >
    </app-icon>
  </div>
</div>

<div class="router-outlet-wrapper">
  <app-global-header-v2
    *ngIf="isIaNavEnabled && (showSideNavigation$ | async)"
  ></app-global-header-v2>
  <router-outlet></router-outlet>
</div>

<app-add-tracked-time></app-add-tracked-time>

<app-error-dialog></app-error-dialog>

<app-growth-dialog
  *ngFor="let canvas of canvases$ | async; trackBy: trackCanvasesByFn"
  [canvas]="canvas"
>
</app-growth-dialog>
